import Schema from './Schema'
import FieldTree from'../fields/FieldTree'
export default class SchemaTree extends Schema {
  constructor(label, key, items, rules, options, on) {
    super(options)
    FieldTree.call(this, label, key, items, rules, options, on)
  }
}



// WEBPACK FOOTER //
// ./packages/helper/schema/SchemaTree.js